import { takeLatest, call, all, fork, put, select, take, race } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  SEARCH_REQUEST,
  SEARCH_CLEAR,
  searchClear,
  searchSuccess,
  searchFailure
} from './actions';

import * as api from './api';

export function* searchRequest({ payload: { query } }) {
  try {
    const language = yield select(state => state.getIn(['user', 'language'])); // TO CHANGE
    const product = yield select(state => state.getIn(['application', 'product']));

    const results = yield call(api.fetchSearch, { query, language, product });

    yield put(searchSuccess(results));
  } catch (e) {
    yield put(searchFailure());
  }
}

export function* watchSearchRequest() {
  while (true) {
    const action = yield take(SEARCH_REQUEST);

    yield race({
      cancel: take(SEARCH_CLEAR),
      task: call(searchRequest, action)
    });
  }
}

export function* handleClearSearch() {
  yield put(searchClear());
}

export default function* root() {
  yield all([
    fork(watchSearchRequest),
    takeLatest(LOCATION_CHANGE, handleClearSearch),
  ]);
}
